/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 02/04/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { PAYMENT_METHOD_KEY } from 'utils/paymentMethodConstants';
import styles from './styles.css';
import TermsAndConditionsBody from './TermsAndConditionsBody';

// These language tokens are used only here since i18n is not supported
const INDONESIAN = 'ID';
const ENGLISH = 'EN';

class TermsAndConditionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: INDONESIAN,
    };
  }

  changeLanguage = () => {
    this.state.language === INDONESIAN
      ? this.setState({ language: ENGLISH })
      : this.setState({ language: INDONESIAN });
  };

  componentDidMount() {
    const { paymentMethodKey } = this.props;
    if (paymentMethodKey != null && paymentMethodKey.code === 'tcash') {
      this.setState({ language: INDONESIAN });
    }
  }

  render() {
    const {
      openTermsAndConditionsModal,
      handleClose,
      paymentMethodKey,
    } = this.props;

    if (!paymentMethodKey) {
      return <div />;
    }

    return (
      <Modal show={openTermsAndConditionsModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles['modal-wrapper']}>
            <div className={styles['language-selector']}>
              <div className="row">
                <div className="col-md-9" />
                <div className="col-md-3">
                  {paymentMethodKey.code === PAYMENT_METHOD_KEY.TCASH && (
                    <button
                      className="btn btn-link"
                      type="button"
                      disabled={this.state.language === INDONESIAN}
                      onClick={this.changeLanguage}
                    >
                      ID
                    </button>
                  )}

                  {[
                    PAYMENT_METHOD_KEY.OVO,
                    PAYMENT_METHOD_KEY.GOPAY,
                    PAYMENT_METHOD_KEY.DANA,
                    PAYMENT_METHOD_KEY.AKULAKU,
                    PAYMENT_METHOD_KEY.KREDIVO,
                    PAYMENT_METHOD_KEY.ALIPAY,
                    PAYMENT_METHOD_KEY.WECHATPAY,
                  ].includes(paymentMethodKey.code) && (
                    <div>
                      <button
                        className="btn btn-link"
                        type="button"
                        disabled={this.state.language === ENGLISH}
                        onClick={this.changeLanguage}
                      >
                        EN
                      </button>
                      <span>|</span>
                      <button
                        className="btn btn-link"
                        type="button"
                        disabled={this.state.language === INDONESIAN}
                        onClick={this.changeLanguage}
                      >
                        ID
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles['body-wrapper']}>
              <div className={styles['modal-body-content']}>
                <div>
                  <TermsAndConditionsBody
                    paymentMethodCode={paymentMethodKey.code}
                    language={this.state.language}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    openTermsAndConditionsModal,
    paymentMethodKey,
  } = state.setting.paymentMethod;
  return {
    openTermsAndConditionsModal,
    paymentMethodKey,
  };
}

export default connect(mapStateToProps)(TermsAndConditionsModal);
